/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* transactionWatcher(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_TRANSACTION_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_V3_ORDER_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_V3_ORDER_DETAILS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ORDER_LEVEL_SUMMARY);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_SETTLEMENT_DETAILS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ORDER_DETAILS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ORDER_REFUND_SETTLEMENT);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_TRANSACTION_FILTER_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_WALLET_NAME_FILTER_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_TRANSACTION_DETAILS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ORDER_SUMMARY_METRICS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.PACB_UPLOAD_INVOICE);
  yield fork(takeLatestUntilApiCancel, ActionConstants.PACB_GET_INVOICE_STATUS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.PACB_UPLOAD_AWB);
  yield fork(takeLatestUntilApiCancel, ActionConstants.PACB_GET_AWB_STATUS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.PACB_BULK_UPLOAD);
  yield fork(takeLatestUntilApiCancel, ActionConstants.PACB_BULK_UPLOAD_HISTORY);
}
